import axios from "axios";

// Custom Component
// import DoRefreshToken from '../components/SignIn/DoRefreshToken'
import SignOut from "../components/SignIn/SignOut";
const store = require("store");

const createTransmittal = async (params) => {
  const createTransmittalAPI = `/transmittal`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3011 + createTransmittalAPI,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updateTransmittal = async (xmtl_seq, params) => {
  const updateTransmittalAPI = `/transmittal/${xmtl_seq}`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3011 + updateTransmittalAPI,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getTransmittalFollowingList = async () => {
  const getTransmittalFollowing = `/transmittal/attr/following`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3011 + getTransmittalFollowing,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getTransmittalDetails = async (xmtl_seq) => {
  const getTransmittalDetails = `/transmittal/${xmtl_seq}`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3011 + getTransmittalDetails,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getTransmittalPurposeList = async () => {
  const getTransmittalPurpose = `/transmittal/attr/purpose`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3011 + getTransmittalPurpose,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getTransmittalList = async () => {
  const getTransmittal = `/transmittal`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3011 + getTransmittal,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const postTransmittalComment = async (xmtl_seq, params) => {
  const postTransmittalCommentAPI = `/transmittal/${xmtl_seq}/comment`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3011 + postTransmittalCommentAPI,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getTransmittalStageList = async (stage_seq) => {
  const transmittalStageListAPI = `/transmittal/attr/${stage_seq}/stage`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3011 + transmittalStageListAPI,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const insertStageAction = async (params) => {
  const insertStageActionAPI = `/transmittal/stageaction`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3011 + insertStageActionAPI,
      headers: headers,
      data: params,
    });
    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const insertTransmittalReturnComment = async (xmtl_seq, params) => {
  const insertTransmittalReturnCommentAPI = `/transmittal/${xmtl_seq}/returncomment`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url:
        process.env.REACT_APP_API_URL_3011 + insertTransmittalReturnCommentAPI,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updateTransmittalApproveStage = async (xmtl_seq, params) => {
  const updatexmtlApproveStageAPI = `/transmittal/${xmtl_seq}/approve`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3011 + updatexmtlApproveStageAPI,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const getUnreadTransmittalCount = async () => {
  const getUnreadTransmittalAPI = `/transmittal/unread/count`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "get",
      url: process.env.REACT_APP_API_URL_3011 + getUnreadTransmittalAPI,
      headers: headers,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const updateTransmittalStage = async (xmtl_seq, params) => {
  const updateTransmittalStageAPI = `/transmittal/${xmtl_seq}/stage`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "patch",
      url: process.env.REACT_APP_API_URL_3011 + updateTransmittalStageAPI,
      headers: headers,
      data: params,
    });

    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const generateTransmittal = async (params) => {
  const generateTransmittalAPI = `/transmittal/download/transmittal`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3011 + generateTransmittalAPI,
      headers: headers,
      data: params,
      responseType: "blob",
    }).then((response) => {
      const blob = new Blob([response.data], { type: response.data.type });
      const downloadUrl = window.URL.createObjectURL(blob);
      // var reader = new FileReader();
      // reader.readAsDataURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      const header_filename = response.headers["download-filename"];
      let filename = "date_time";
      if (header_filename) {
        filename = decodeURIComponent(header_filename);
      }
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const saveTransmittal = async (params) => {
  const saveTransmittalAPI = `/transmittal/download/transmittal/upload`;
  let result;

  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };

    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3011 + saveTransmittalAPI,
      headers: headers,
      data: params,
    });
    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

const transferTransmittaltoEfiling = async (params) => {
  const transferXmtlAPI = `/transmittal/transfer`;
  let result;
  try {
    let headers = {
      Authorization: "Bearer " + store.get("access_token"),
      site: store.get("site"),
      locale: store.get("locale"),
    };
    result = await axios({
      method: "post",
      url: process.env.REACT_APP_API_URL_3011 + transferXmtlAPI,
      headers: headers,
      data: params,
    });
    return result.data;
  } catch (error) {
    try {
      if (error.response.status === 401) {
        // DoRefreshToken()
        SignOut();
      } else {
        throw new Error(error);
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

export {
  getTransmittalFollowingList,
  getTransmittalPurposeList,
  getTransmittalStageList,
  createTransmittal,
  getTransmittalDetails,
  getTransmittalList,
  postTransmittalComment,
  insertTransmittalReturnComment,
  insertStageAction,
  getUnreadTransmittalCount,
  updateTransmittal,
  updateTransmittalStage,
  generateTransmittal,
  updateTransmittalApproveStage,
  saveTransmittal,
  transferTransmittaltoEfiling,
};
